import { render } from "./AchievementsPage.vue?vue&type=template&id=4ca76e4d&scoped=true"
import script from "./AchievementsPage.vue?vue&type=script&lang=js"
export * from "./AchievementsPage.vue?vue&type=script&lang=js"

import "./AchievementsPage.vue?vue&type=style&index=0&id=4ca76e4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca76e4d"]])

export default __exports__